import { render, staticRenderFns } from "./productout.vue?vue&type=template&id=2b751132&scoped=true"
import script from "./productout.vue?vue&type=script&lang=js"
export * from "./productout.vue?vue&type=script&lang=js"
import style0 from "./productout.vue?vue&type=style&index=0&id=2b751132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b751132",
  null
  
)

export default component.exports